export default Object.freeze({
  info: {},
  stats: {},

  activeMapLastShiftID: null,

  shiftReportLinks: {}
});
